import React, { useEffect } from "react";
import {
  Grid,
  Typography,
  Box,
  MenuItem,
  Select,
  FormControl,
  Button,
  FormHelperText,
  TextField,
} from "@material-ui/core";
import InputMask from "react-input-mask";
import { connect } from "react-redux";
import bigInt from "big-integer";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import { makeStyles } from "@material-ui/core/styles";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import styles from "../../../../styles/global-styles";
import { ProviderService } from "../../../../services/provider.service";
import NumberFormatCustom from "../../../stateless/NumberFormatCustom";
import { actions } from "../../../../redux/actions/alert";
import { ChipCatalogueService } from "../../../../services/chipCatalogue.service";

const useStyles = makeStyles((theme) => ({
  form: {
    width: "auto", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  box: {
    marginTop: "20px",
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  backgroundIcon: styles.backgroundIcon,
  formControl: styles.globalFormControl,
  label: styles.label,
}));

const ChipForm = ({ addAlert, detailAlert, newChipCreated }) => {
  const classes = useStyles();

  const [newChip, setNewChip] = React.useState({});
  const [providerArray, setProviderArray] = React.useState([]);
  const [chipArray, setChipArray] = React.useState([]);
  /** Error messages */
  const [hasError, setHasError] = React.useState(false);
  const [hasErrorChip, setHasErrorChip] = React.useState(false);
  const [timeGuarantee, setTimeGuarantee] = React.useState("");
  const [barCode, setBarCode] = React.useState("");

  useEffect(() => {
    (async function fetchData() {
      try {
        const { data } = await ProviderService.getAllProviders();
        const result = await ChipCatalogueService.getChipCatalogue();
        setProviderArray(data);
        setChipArray(result.data);
      } catch (error) {
        addAlert({ showAlert: true });
        detailAlert({ severity: "error", message: error.msgs });
      }
    })();
  }, []);

  const handleInputText = ({ target: { name, value } }) => {
    if (name === "providerId" && value) setHasError(false);
    if (name === "iccidInit" || name === "iccidEnd")
      setNewChip({ ...newChip, [name]: bigInt(value).value });
    if (name === "chipCatalogueId") {
      setHasErrorChip(false);
      const { id } = chipArray.find((chip) => chip.id === value);
      setNewChip({ ...newChip, chipCatalogueId: id });
    }
    fillArrayForms(name, value);
    setNewChip({ ...newChip, [name]: value });
  };

  const validateIccidRange = () => {
    if (newChip.iccidInit >= newChip.iccidEnd) {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "warning",
        message:
          "El rango de inicio es MAYOR o IGUAL al rango de fin, favor de corregir",
      });
      return false;
    } else return true;
  };

  const fillArrayForms = (name, value) => {
    if (name === "providerId") {
      providerArray.forEach((element) => {
        if (element.id === value) {
          setTimeGuarantee(element.timeGuarantee);
        }
      });
    }
    if (name === "chipCatalogueId") {
      chipArray.forEach((element) => {
        if (element.id === value) {
          setBarCode(element.barCode);
        }
      });
    }
  };

  const handleSubmitForm = (event) => {
    event.preventDefault();
    if (newChip.providerId === undefined) {
      setHasError(true);
      return;
    }
    if (newChip.chipCatalogueId === undefined) {
      setHasErrorChip(true);
      return;
    }
    if (!validateIccidRange()) {
      return;
    }
    newChipCreated(newChip, 'chip');
  };

  return (
    <React.Fragment>
      <ValidatorForm
        noValidate
        onKeyPress={(event) => {
          if (event.which === 13 /* Enter */) {
            event.preventDefault();
          }
        }}
        className={classes.form}
        method="POST"
        onSubmit={handleSubmitForm}
        onError={(errors) => {
          if (newChip.providerId === undefined) {
            setHasError(true);
          }
        }}
      >
        <Typography variant="h6">
          <Box mt={6} style={{ fontWeight: "bold", color: "#1C2668" }}>
            Seleccionar los rangos de ICCID
          </Box>
        </Typography>
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
        >
          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <Box className={classes.box}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Inicio
              </Typography>
              <InputMask
                mask="9999999999999999999"
                maskChar=""
                value={newChip.iccidInit || ""}
                onChange={(e) => handleInputText(e)}
              >
                {() => (
                  <TextValidator
                    name="iccidInit"
                    validators={["required"]}
                    errorMessages={["Es necesario ingresar el rango de inicio"]}
                    variant="outlined"
                    inputProps={{
                      maxLength: 19,
                    }}
                  ></TextValidator>
                )}
              </InputMask>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <Box className={classes.box}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Fin
              </Typography>
              <InputMask
                mask="9999999999999999999"
                maskChar=""
                value={newChip.iccidEnd || ""}
                onChange={(e) => handleInputText(e)}
              >
                {() => (
                  <TextValidator
                    name="iccidEnd"
                    validators={["required"]}
                    errorMessages={["Es necesario ingresar el rango de fin"]}
                    variant="outlined"
                    inputProps={{
                      maxLength: 19,
                    }}
                  ></TextValidator>
                )}
              </InputMask>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <Box className={classes.box}>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                error={hasErrorChip}
              >
                <Typography
                  variant="body2"
                  component={"div"}
                  className={classes.label}
                >
                  Tipo de chip
                </Typography>

                <Select
                  disabled={false}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="chipCatalogueId"
                  required
                  value={newChip.chipCatalogueId || ""}
                  onChange={(e) => handleInputText(e)}
                >
                  {chipArray.map((chip, id) => {
                    return (
                      <MenuItem key={id} value={chip.id}>
                        {chip.name}
                      </MenuItem>
                    );
                  })}
                </Select>
                {hasErrorChip && (
                  <FormHelperText>
                    Es necesario seleccionar el tipo de chip
                  </FormHelperText>
                )}
              </FormControl>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <Box className={classes.box}>
              <FormControl variant="outlined" className={classes.formControl}>
                <Typography
                  variant="body2"
                  component={"div"}
                  className={classes.label}
                >
                  Código de barras
                </Typography>

                <TextValidator
                  InputProps={{
                    readOnly: true,
                  }}
                  value={barCode || ""}
                  variant="outlined"
                  inputProps={{
                    maxLength: 20,
                  }}
                ></TextValidator>
              </FormControl>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <Box className={classes.box}>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                error={hasError}
              >
                <Typography
                  variant="body2"
                  component={"div"}
                  className={classes.label}
                >
                  Proveedor
                </Typography>

                <Select
                  disabled={false}
                  name="providerId"
                  required
                  value={newChip.providerId || ""}
                  onChange={(e) => handleInputText(e)}
                >
                  {providerArray.map((product, id) => {
                    return (
                      <MenuItem key={id} value={product.id}>
                        {product.name}
                      </MenuItem>
                    );
                  })}
                </Select>
                {hasError && (
                  <FormHelperText>
                    Es necesario seleccionar un proveedor
                  </FormHelperText>
                )}
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <Box className={classes.box}>
              <FormControl variant="outlined" className={classes.formControl}>
                <Typography
                  variant="body2"
                  component={"div"}
                  className={classes.label}
                >
                  Garantía
                </Typography>

                <TextValidator
                  InputProps={{
                    readOnly: true,
                  }}
                  value={timeGuarantee || ""}
                  variant="outlined"
                  inputProps={{
                    maxLength: 4,
                  }}
                ></TextValidator>
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <Box className={classes.box}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Costo
              </Typography>
              <TextField
                name="cost"
                value={newChip.cost || ""}
                onChange={(e) => handleInputText(e)}
                variant="outlined"
                InputProps={{
                  inputComponent: NumberFormatCustom,
                }}
              ></TextField>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <Box className={classes.box}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Precio
              </Typography>

              <TextField
                name="price"
                value={newChip.price || ""}
                onChange={(e) => handleInputText(e)}
                variant="outlined"
                InputProps={{
                  inputComponent: NumberFormatCustom,
                }}
              ></TextField>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <Box className={classes.inputBoxSpace}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Lote
              </Typography>
              <TextValidator
                name="lote"
                value={newChip.lote || ""}
                validators={["required"]}
                onChange={(e) => handleInputText(e)}
                errorMessages={["El lote es requerido"]}
                variant="outlined"
              ></TextValidator>
            </Box>
          </Grid>

          <Grid container direction="row" justify="center" alignItems="center">
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                style={{ marginTop: "40px", fontSize: 14, width: 150 }}
                endIcon={
                  <ArrowRightAltIcon
                    className={classes.backgroundIcon}
                    color="primary"
                  ></ArrowRightAltIcon>
                }
              >
                Inventario
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </ValidatorForm>
    </React.Fragment>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(ChipForm);
